'use strict';

import React from 'react';
import classNames from 'classnames';

class DisplayField extends React.Component {
    render() {
        var classes = classNames(
            'fc-input', this.props.className, {
                'disabled': this.props.disabled,
                'no-label': !this.props.label,
            }
        );

        return (
            <div id={'form-element-{0}'.format(this.props.name)} className={classes}>
                {this.props.label ? <label>{this.props.label}</label> : null}
                <div id={this.props.name} className="displayField">{this.props.value}</div>
            </div>
        );
    }
}

export default DisplayField; 